import { OrderType } from '@/constants/enum';
import { SearchParamsType } from '@/types/menus';
import { buildScanToOrderSearchParams, extractScanToOrderParams } from '@/utils/scanToOrderUtils';

export const getMenuQueryParams = (searchParams: SearchParamsType) => {
  const { menuName, orderType, tableId, employeeId } = extractScanToOrderParams(searchParams);

  let validOrderType: OrderType | undefined = undefined;
  if (orderType && Object.values(OrderType).includes(orderType.toUpperCase() as OrderType)) {
    validOrderType = orderType.toUpperCase() as OrderType;
  }

  let params = '';
  if (orderType || tableId || employeeId) {
    params = buildScanToOrderSearchParams({
      orderType: validOrderType,
      tableId: tableId ?? undefined,
      employeeId: employeeId ?? undefined,
    });
  }

  if (menuName) {
    params += params ? `&menu=${menuName}` : `?menu=${menuName}`;
  }

  return params;
};
